<template>
  <div class="no_data">
    <img class="no_img" src="https://web.nlktj.com/ty/merchant/noDataPic.png" alt="">
    <span>暂无数据</span>
  </div>
</template>
<script>
export default {
  data () {
    return {}
  }
}
</script>
<style scoped lang="less">
.no_data{
  width: 100%;
  height: 350px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .no_img{
    display: block;
    width: 89px;
    height: 80px;
  }
  >span{
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #999999;
    margin-right: 10px;
  }
}
</style>